import React from 'react';
import Relay from 'react-relay';

class TodoListNew extends React.Component {
  static propTypes = {
    viewer: React.PropTypes.object.isRequired
  };

  render() {
    console.log('this.props.viewer', this.props.viewer);
    return (
      <div>
        <div>
          {this.renderConversation()}
        </div>
        <div>
          This.is.hello.world
        </div>
      </div>
    );
  }

  renderConversation() {
    return this.props.viewer.conversations.map((object, index) => {
      console.log('object', object)
      return (
        <div>
          {object.name}
        </div>
      )
    });
  }
}

export default Relay.createContainer(TodoListNew, {
  initialVariables: {
    status: null
  },
  fragments: {
    viewer: () => Relay.QL`
      fragment on User {
        pid
        conversations {
          name
        }
      }
    `
  }
});



/** WEBPACK FOOTER **
 ** ./src/components/TodoListNew.js
 **/